export default __webpack_public_path__ + "static/media/Suyane_Mike_HickDuarte_33731.20cd13e4.jpg";